import { PERIODS, TIERS, type Segment, type TierId } from './catalog';

export interface Selection {
  tier: TierId;
  segment: Segment;
  periodMonths: number;
  stops: Record<TierId, number>;
}

export const defaultSelection: Selection = {
  tier: 'growth', segment: 'biz', periodMonths: 3,
  stops: { starter: 0, growth: 0, premium: 0 },
};

/** Recover safely from stale or edited sessionStorage before calculating a quote. */
export function parseSponsorSelection(raw: string | null): Selection {
  const selection: Selection = { ...defaultSelection, stops: { ...defaultSelection.stops } };
  try {
    const value: unknown = raw ? JSON.parse(raw) : null;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) return selection;
    const candidate = value as Record<string, unknown>;
    const tier = TIERS.find((tier) => tier.id === candidate.tier);
    if (tier) selection.tier = tier.id;
    if (candidate.segment === 'biz' || candidate.segment === 'ngo') selection.segment = candidate.segment;
    const period = PERIODS.find((period) => period.months === candidate.periodMonths);
    if (period) selection.periodMonths = period.months;
    if (typeof candidate.stops === 'object' && candidate.stops !== null && !Array.isArray(candidate.stops)) {
      const stops = candidate.stops as Record<string, unknown>;
      for (const tier of TIERS) {
        const stop = stops[tier.id];
        if (typeof stop === 'number' && Number.isSafeInteger(stop) && stop >= 0 && stop < tier.prices.length) {
          selection.stops[tier.id] = stop;
        }
      }
    }
  } catch {
    return selection;
  }
  return selection;
}
